import { render, staticRenderFns } from "./RoleFilter.vue?vue&type=template&id=12a9cd60&scoped=true"
import script from "./RoleFilter.vue?vue&type=script&lang=js"
export * from "./RoleFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a9cd60",
  null
  
)

export default component.exports